"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AceSSR = exports.hasAceSSR = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const SSR = typeof window === "undefined";
/* eslint-disable no-var,@typescript-eslint/no-var-requires */
if (SSR) {
    var JSDOM = require("jsdom").JSDOM;
    const jsdom = new JSDOM("<!doctype html><html><body></body></html>");
    global.window = jsdom.window;
    var ace = require("ace-builds");
    var cheerio = require("cheerio");
    var parseUnit = require("parse-unit");
    delete global.window;
}
require("./AceSSR.scss");
const ssrPostfix = "___ssr";
exports.hasAceSSR = (id) => typeof window !== "undefined" && document.getElementById(`${id}${ssrPostfix}`) !== null;
exports.AceSSR = ({ id, theme, mode, value, defaultValue, maxLines, extraLines, style, width, fontSize, className = "", numbers, ...props }) => {
    const ssrID = `${id}___ssr`;
    const lineHeight = typeof props.lineHeight === "number" ? `${props.lineHeight}px` : props.lineHeight;
    if (SSR) {
        const [lineHeightNumber, lineHeightUnit] = parseUnit(lineHeight);
        const jsdom = new JSDOM("<!doctype html><html><body></body></html>");
        const { window } = jsdom;
        const { document } = window;
        global.window = window;
        global.document = document;
        /*
         * The exact values for these width and height properties don't matter, since we'll patch them later.
         * They just need to be non-zero or Ace will refuse to render our content.
         */
        Object.defineProperties(window.HTMLElement.prototype, {
            clientWidth: {
                get: function () {
                    return 512;
                },
            },
            offsetWidth: {
                get: function () {
                    return 512;
                },
            },
            clientHeight: {
                get: function () {
                    return 100;
                },
            },
        });
        window.HTMLElement.prototype.getBoundingClientRect = function () {
            return { width: 256 };
        };
        const aceContainer = document.createElement("div");
        aceContainer.setAttribute("id", id);
        document.body.appendChild(aceContainer);
        const editor = ace.edit(id);
        if (mode !== "") {
            require(`ace-builds/src-noconflict/mode-${mode}`);
            editor.getSession().setMode(`ace/mode/${mode}`);
        }
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const themeCSS = theme !== "" ? require(`ace-builds/src-noconflict/theme-${theme}`).cssText : undefined;
        themeCSS && editor.setTheme(`ace/theme/${theme}`);
        editor.setFontSize(fontSize);
        editor.setOption("maxLines", Infinity);
        const initialValue = (!defaultValue ? value : defaultValue) || "";
        editor.getSession().setValue(initialValue);
        editor.setOption("showLineNumbers", numbers);
        editor.resize(true);
        const editorElement = document.getElementById(id);
        window.close();
        // eslint-disable-next-line no-native-reassign
        delete global.window;
        delete global.document;
        const $ = cheerio.load(editorElement.outerHTML);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $("div").each(function (_, elem) {
            if ($(elem).css("visibility") === "hidden") {
                $(elem).remove();
                return;
            }
            $(elem).css("transform", "");
            if ($(elem).css("height") === "1000000px") {
                $(elem).css("height", "");
            }
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $("span").each(function (_, elem) {
            if ($(elem).css("display") === "none") {
                $(elem).remove();
            }
        });
        $(".ace_gutter-active-line").removeClass("ace_gutter-active-line");
        $(".ace_content").css("width", "");
        $(".ace_print-margin-layer").remove();
        $(".ace_marker-layer").remove();
        $(".ace_cursor-layer").remove();
        $(".ace_scrollbar").remove();
        $(".ace_layer").css("pointer-events", "auto");
        $(".ace_scroller").css("user-select", "text");
        $(".ace_scroller").css("-ms-user-select", "text");
        $(".ace_scroller").css("-moz-user-select", "text");
        $(".ace_scroller").css("-webkit-user-select", "text");
        $(".ace_scroller").css("line-height", `${lineHeightNumber}${lineHeightUnit}`);
        $(".ace_scroller").css("left", props.gutterWidth);
        $(".ace_gutter, .ace_gutter-layer").css("width", props.gutterWidth);
        $("textarea").remove();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $(".ace_gutter-cell, .ace_line").each(function (_, elem) {
            const [heightNumber, heightUnit] = parseUnit($(elem).css("height"));
            const [topNumber, topUnit] = parseUnit($(elem).css("top"));
            if (heightNumber % 100 !== 0 || heightUnit !== "px" || topNumber % 100 !== 0 || topUnit !== "px") {
                throw Error("Gutter height problem");
            }
            $(elem).css("height", `${lineHeightNumber}${lineHeightUnit}`);
            const multiplier = Math.floor(topNumber / 100);
            $(elem).css("top", `${multiplier * lineHeightNumber}${lineHeightUnit}`);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $(".ace_line").each(function (_, elem) {
            $(elem).append("<br>");
        });
        const contentHeightInLines = initialValue.split("\n").length;
        const heightInLines = Math.min(contentHeightInLines, maxLines || Infinity);
        const height = props.height || `${(heightInLines + (extraLines || 0)) * lineHeightNumber}${lineHeightUnit}`;
        $(".ace_content, .ace_text-layer, .ace_gutter, .ace_scroller").css("height", `${contentHeightInLines * lineHeightNumber}${lineHeightUnit}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $(".ace_content").each(function (_, elem) {
            elem.tagName = "code";
        });
        return (react_1.default.createElement("div", { id: ssrID },
            themeCSS && react_1.default.createElement("style", { dangerouslySetInnerHTML: { __html: themeCSS } }),
            react_1.default.createElement("div", { style: {
                    height,
                    width,
                    fontSize,
                    overflow: "auto",
                    ...style,
                }, className: `${editorElement.className.trim()} ${className}`.trim(), dangerouslySetInnerHTML: { __html: $(`#${id}`).html() } })));
    }
    /* eslint-enable @typescript-eslint/no-var-requires */
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const serverContent = react_1.useRef(!SSR && document.getElementById(ssrID)?.innerHTML);
    if (!serverContent.current) {
        return null;
    }
    return react_1.default.createElement("div", { id: ssrID, dangerouslySetInnerHTML: { __html: serverContent.current } });
};
exports.AceSSR.propTypes = {
    id: prop_types_1.default.string.isRequired,
    numbers: prop_types_1.default.bool.isRequired,
    gutterWidth: prop_types_1.default.string.isRequired,
    mode: prop_types_1.default.string,
    theme: prop_types_1.default.string,
    value: prop_types_1.default.string,
    defaultValue: prop_types_1.default.string,
    style: prop_types_1.default.any,
    lineHeight: prop_types_1.default.oneOfType([prop_types_1.default.number.isRequired, prop_types_1.default.string.isRequired]).isRequired,
    maxLines: prop_types_1.default.number,
    extraLines: prop_types_1.default.number,
    height: prop_types_1.default.string,
    width: prop_types_1.default.string,
    fontSize: prop_types_1.default.string,
    className: prop_types_1.default.string,
};
exports.AceSSR.defaultProps = {
    mode: "",
    theme: "",
    value: "",
    width: "500px",
    fontSize: "12px",
    extraLines: 0,
    className: "",
};
//# sourceMappingURL=AceSSR.js.map